import { Radio, TextareaAutosize, TextField } from '@mui/material';
import { useField } from 'formik';
import React, { Fragment } from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';

const CustomTextField = (props) => {
  const {
    label,
    variant,
    type,
    name,
    value,
    onChange,
    onBlur,
    placeholder,
    required,
    margin,
    id,
    InputProps,
    disabled,
    inputProps,
    className,
    fieldType,
    fullWidth,
    inputRef,

    ...rest
  } = props;

  return (
    <Fragment>
      {fieldType === 'textArea' && (
        <TextareaAutosize
          required={required}
          type={type}
          label={label}
          variant={variant}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          margin={margin}
          id={id}
          InputProps={InputProps}
          disabled={disabled}
          fullWidth={fullWidth}
          inputProps={inputProps}
          className={className}
          {...rest}
        />
      )}
      {fieldType === 'textInput' && (
        <TextField
          inputRef={inputRef}
          required={required}
          type={type}
          label={label}
          variant={variant}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          margin={margin}
          id={id}
          fullWidth={fullWidth}
          InputProps={InputProps}
          disabled={disabled}
          inputProps={inputProps}
          className={className}
          {...rest}
        />
      )}
      {fieldType === 'simpleTextInput' && (
        <OutlinedInput
          inputRef={inputRef}
          required={required}
          type={type}
          label={label}
          variant={variant}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          margin={margin}
          id={id}
          fullWidth={fullWidth}
          InputProps={InputProps}
          disabled={disabled}
          inputProps={inputProps}
          className={className}
          {...rest}
        />
      )}
    </Fragment>
  );
};

export default CustomTextField;
